import moment from 'moment';
import ProposalTableProspects from 'apps/proposals/components/proposal-table-prospects';
import { Icon, Link } from '@evertrue/et-components';
import { getHumanReadableTimeFromNow } from 'apps/proposals/components/proposal-form-utils';
import ProposalTableSolicitors from './proposal-table-solicitors';
import { proposalSolicitor } from '../utils';
import numeral from 'numeral';

const formatDate = (date) => (
  <span className="fs-exclude-data">{date ? moment(date).format('MMM DD, YYYY') : '-'}</span>
);
const formatTitle = (title) => {
  if (title) {
    return title.length > 50 ? title.substring(0, 50) + '...' : title;
  }

  return 'Untitled';
};

const ProposalTableColumns = (userContactId) => {
  return [
    {
      field: 'proposal',
      headerName: 'Proposal',
      minWidth: 240,
      flex: 1,
      sortable: false,
      hideable: false,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        const userProposalContact = proposalSolicitor(data.solicitors, userContactId);
        return (
          <div>
            <div className="proposal-table--first-col fs-exclude-data">
              <Icon
                className={
                  userProposalContact.key_proposal
                    ? 'proposal-table--key-proposal-star'
                    : 'proposal-table--proposal-star'
                }
                title={userProposalContact.key_proposal ? 'Key proposal' : 'Not a key proposal'}
                icon="star"
                size={1}
              />
              <Link href={`/proposal/${data.id}`} className="proposal-table--proposal-link">
                {formatTitle(data.title)}
              </Link>
            </div>
          </div>
        );
      },
    },
    {
      field: 'prospect',
      headerName: 'Prospect',
      minWidth: 180,
      flex: 1,
      sortable: false,
      hideable: false,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return <ProposalTableProspects proposal={data} />;
      },
    },
    {
      field: 'original_ask_amount',
      headerName: 'Original Ask',
      minWidth: 120,
      flex: 1,
      sortable: true,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return (
          <div className="fs-exclude-data">
            {data.original_ask_amount != null ? numeral(data.original_ask_amount).format('$0,0') : '-'}
          </div>
        );
      },
    },
    {
      field: 'expected_amount',
      headerName: 'Expected Ask',
      minWidth: 120,
      flex: 1,
      sortable: true,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return (
          <div className="fs-exclude-data">
            {data.expected_amount != null ? numeral(data.expected_amount).format('$0,0') : '-'}
          </div>
        );
      },
    },
    {
      field: 'stage',
      headerName: 'Stage',
      minWidth: 120,
      flex: 1,
      sortable: false,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return <div className="fs-exclude-data">{data.status || '-'}</div>;
      },
    },
    {
      field: 'status_start_date',
      headerName: 'Time in Stage',
      minWidth: 120,
      flex: 1,
      sortable: true,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return <div className="fs-exclude-data">{getHumanReadableTimeFromNow(data.status_start_date)}</div>;
      },
    },
    {
      field: 'solicitors',
      headerName: 'Solicitors',
      minWidth: 120,
      flex: 1,
      sortable: false,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return <ProposalTableSolicitors solicitors={data.solicitors} userContactId={userContactId} />;
      },
    },
    {
      field: 'ask_date',
      headerName: 'Ask Date',
      minWidth: 120,
      flex: 1,
      sortable: true,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return formatDate(data.ask_date);
      },
    },
    {
      field: 'created_date',
      headerName: 'Created Date',
      minWidth: 120,
      flex: 0.5,
      sortable: true,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return formatDate(data.created_date);
      },
    },
    {
      field: 'expected_date',
      headerName: 'Expected Date',
      minWidth: 120,
      flex: 1,
      sortable: true,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return formatDate(data.expected_date);
      },
    },
    {
      field: 'funded_date',
      headerName: 'Funded Date',
      minWidth: 120,
      flex: 1,
      sortable: true,
      renderCell: ({ row }) => {
        const data = row.rawData || row;
        return formatDate(data.funded_date);
      },
    },
  ];
};

export default ProposalTableColumns;
